<a [class]="'link _cancel ' + fromSize(size)" [class._disabled]="disabled">
    <ng-content></ng-content>
</a>
